import { useEffect, useState } from 'react';
import { api } from '../../api';

interface ClienteBusca { id: string; razao_social: string; nome_fantasia: string | null }
interface LocalItem { id: string; nome: string; ativo: boolean }
export interface Escolha { cliente_id: string | null; cliente: string | null; local_id: string | null }

/** Cliente (busca) + local (lista do cliente). Cliente com um local só já vem escolhido. */
export function EscolherLocal({ valor, aoMudar, clienteFixo }: { valor: Escolha; aoMudar: (e: Escolha) => void; clienteFixo?: boolean }) {
  const [busca, setBusca] = useState('');
  const [achados, setAchados] = useState<ClienteBusca[]>([]);
  const [locais, setLocais] = useState<LocalItem[]>([]);

  useEffect(() => {
    if (!busca.trim() || valor.cliente_id) return setAchados([]);
    const t = setTimeout(() => api<{ itens: ClienteBusca[] }>(`/clientes?busca=${encodeURIComponent(busca)}`).then((r) => setAchados(r.itens.slice(0, 8))).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [busca, valor.cliente_id]);
  useEffect(() => {
    if (!valor.cliente_id) return setLocais([]);
    api<{ locais: LocalItem[] }>(`/clientes/${valor.cliente_id}`).then((c) => {
      const ativos = c.locais.filter((l) => l.ativo);
      setLocais(ativos);
      if (ativos.length === 1 && !valor.local_id) aoMudar({ ...valor, local_id: ativos[0]!.id });
    }).catch(() => {});
  }, [valor.cliente_id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="linha-2">
      <div className="campo"><span className="rotulo-campo">Cliente</span>
        {valor.cliente_id ? (
          <div className="campo-mascarado"><span>{valor.cliente}</span>
            {!clienteFixo && <button type="button" className="btn-link" onClick={() => aoMudar({ cliente_id: null, cliente: null, local_id: null })}>trocar</button>}</div>
        ) : (
          <div className="autocompletar">
            <input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Nome do condomínio ou empresa" aria-label="Buscar cliente" />
            {achados.length > 0 && <ul>{achados.map((c) => (
              <li key={c.id}><button type="button" onClick={() => { aoMudar({ cliente_id: c.id, cliente: c.nome_fantasia ?? c.razao_social, local_id: null }); setBusca(''); }}>
                <strong>{c.nome_fantasia ?? c.razao_social}</strong>{c.nome_fantasia && <small>{c.razao_social}</small>}</button></li>))}</ul>}
          </div>
        )}
      </div>
      <label>Parque
        <select value={valor.local_id ?? ''} onChange={(e) => aoMudar({ ...valor, local_id: e.target.value || null })} disabled={!valor.cliente_id}>
          <option value="">{valor.cliente_id ? 'Escolha' : 'Escolha o cliente primeiro'}</option>
          {locais.map((l) => <option key={l.id} value={l.id}>{l.nome}</option>)}
        </select>
      </label>
    </div>
  );
}
